module.exports = __webpack_public_path__ + "static/media/icon-chamar-paciente.d82621fb.svg";